const uz = {
    meta: {
        title: "Internet do'kon qanday ishlaydi va kimga foyda beradi",
        description:
            "Internet do'kon qanday ishlaydi, nimalardan qurilgan va qancha turadi. Narx 16 mln so'mdan, marketpleys bilan taqqoslash, qaytim hisobi va qonuniy talablar.",
        keywords: [
            "internet do'kon",
            "onlayn do'kon",
            "internet do'kon qanday ishlaydi",
            "internet do'kon qaytimi",
            "elektron tijorat",
            "onlayn savdo",
            "marketpleys yoki o'z do'koni",
        ],
    },
    h1: "Internet do'kon: qanday ishlaydi, qancha turadi va qachon o'zini oqlaydi",
    lead:
        "Internet do'kon — savdo nuqtasi emas, hisoblanadigan kanal. Do'kon nimalardan qurilishini, O'zbekistonda qanday qonuniy talablar borligini, marketpleysga nisbatan qachon foydali ekanini va qaytimni qanday hisoblashni ko'rib chiqamiz.",
    category: "Elektron tijorat",
    readingTime: "11 daqiqa",

    body: [
        {
            type: "p",
            text:
                "«Marketpleysda sotyapmiz, o'z do'konimiz kerakmi?» — bu bizga eng ko'p beriladigan savol. Javob aylanmangizga va komissiya foiziga bog'liq, boshqa hech narsaga emas. Quyida shu hisobni ochiq ko'rsatamiz.",
        },

        { type: "h2", text: "Internet do'kon nima va u qanday ishlaydi?" },
        {
            type: "p",
            text:
                "Internet do'kon — tovarni internet orqali sotishga mo'ljallangan sayt. Xaridor kompyuter yoki smartfonda tovarni tanlaydi, buyurtmani rasmiylashtiradi, to'lov va yetkazib berish usulini belgilaydi. Savdo masofadan amalga oshadi — sotuvchi va xaridor uchrashmaydi.",
        },
        {
            type: "p",
            text:
                "Xaridor nuqtai nazaridan savdo uch qadamda kechadi. Birinchi qadam — katalog: tovarlar toifalarga ajratilgan, har birida fotosurat, narx va tavsif bor. Bu oddiy do'kondagi javon bilan bir xil vazifani bajaradi, faqat javon cheksiz.",
        },
        {
            type: "p",
            text:
                "Ikkinchi qadam — savat. Xaridor tanlaganini savatga soladi, umumiy summani ko'radi, miqdorni o'zgartiradi yoki ortiqchasini olib tashlaydi. Uchinchi qadam — buyurtmani rasmiylashtirish: aloqa ma'lumotlari, yetkazib berish manzili va to'lov usuli. Shu daqiqada buyurtma sotuvchi tizimiga tushadi.",
        },
        { type: "image", image: 1 },
        {
            type: "p",
            text:
                "Ko'rinmaydigan qism ham shu yerda boshlanadi: buyurtma admin panelda paydo bo'ladi, ombor qoldig'i kamayadi, mijozga tasdiq ketadi, kuryerga topshiriq shakllanadi. Bu zanjir avtomatlashtirilmasa, do'kon oyiga 200 buyurtmadan keyin qo'lda boshqarilmaydi.",
        },

        { type: "h2", text: "Internet do'kon nimalardan qurilgan?" },
        {
            type: "p",
            text:
                "Tashqaridan do'kon bitta sayt bo'lib ko'rinadi, aslida u kamida beshta qismdan iborat. Narxni tushunish uchun shu bo'linishni bilish kerak.",
        },
        { type: "image", image: 3 },
        {
            type: "list",
            items: [
                "Vitrina — xaridor ko'radigan qism: katalog, filtrlar, qidiruv, tovar kartochkasi, savat va buyurtma formasi.",
                "Admin panel — tovar qo'shish, narx va qoldiqni o'zgartirish, buyurtmalarni ko'rish va holatini yuritish.",
                "To'lov moduli — Payme va Click integratsiyasi, shuningdek yetkazib berishda naqd to'lov varianti.",
                "Yetkazib berish — hududlar, tariflar, minimal buyurtma summasi va kuryer xizmati bilan bog'lanish.",
                "Tahlil — qaysi tovar ko'rilyapti, savatdan qaysi bosqichda chiqib ketishyapti, reklama qaysi kanaldan buyurtma keltiryapti.",
            ],
        },
        {
            type: "p",
            text:
                "Qo'shimcha sifatida CRM va Telegram bot keladi. CRM takroriy sotuvni yuritadi: mijoz bazasi, qo'ng'iroqlar tarixi, tashlab ketilgan savatlarga qaytish. Bot esa buyurtma holatini xabar qiladi va odatda mobil ilovadan tezroq ishga tushadi.",
        },

        { type: "h2", text: "Internet do'kon oddiy do'kondan nimasi bilan yaxshiroq?" },
        {
            type: "p",
            text:
                "Onlayn savdoning afzalligi chiroyli dizaynda emas, iqtisodda. Quyidagi beshta band — bu oddiy nuqtada printsipial ravishda mumkin bo'lmagan narsalar.",
        },
        {
            type: "list",
            items: [
                "Kuniga 24 soat, yiliga 365 kun ishlaydi. Tushlik, dam olish kuni va bayramda ham buyurtma qabul qilinadi — sotuvchi uxlaganda ham.",
                "Hududiy chegara yo'q. Toshkentdagi do'kon Farg'ona yoki Nukusdagi xaridorga xuddi qo'shni ko'chadagidek yaqin.",
                "Assortiment cheklanmagan: javon joyi tugamaydi, 50 ta tovar ham, 50 000 ta ham bitta vitrinaga sig'adi.",
                "Har bir harakat o'lchanadi: qaysi tovar necha marta ko'rilgani va savatdan qaysi bosqichda chiqib ketilgani ko'rinadi. Oddiy do'konda buni bilib bo'lmaydi.",
                "Ijara va sotuvchi xarajati tushadi. Bitta savdo nuqtasi o'rniga bitta ombor va bitta operator yetadi.",
            ],
        },
        {
            type: "p",
            text:
                "Muhim ogohlantirish: bu afzalliklar do'konni ochgan kuniyoq ishlamaydi. Oddiy do'konga odam ko'chadan o'zi kiradi, internet do'konga esa trafikni siz olib kelasiz. Aynan shu farq ko'pchilik loyihani muvaffaqiyatsiz qiladi.",
        },

        { type: "h2", text: "O'zbekistonda onlayn savdoga qanday qoidalar qo'llaniladi?" },
        {
            type: "p",
            text:
                "Asosiy hujjat — «Elektron tijorat to'g'risida»gi Qonun, yangi tahrirda 2022-yil sentyabrda qabul qilingan (O'RQ-792-son). Unga ko'ra elektron tijoratdagi elektron hujjatlar qog'ozda rasmiylashtirilgan va qo'l bilan imzolangan hujjatlarga tenglashtiriladi. Ya'ni saytdagi buyurtma — bu haqiqiy shartnoma.",
        },
        {
            type: "p",
            text:
                "Qonunga muvofiq elektron savdo maydonchasida sotuvchi bo'lib yuridik shaxslar, yakka tartibdagi tadbirkorlar hamda o'zini o'zi band qilgan shaxslar faoliyat yuritishi mumkin. Ya'ni onlayn savdoni boshlash uchun rasmiy maqom kerak — «shunchaki sotib ko'raman» varianti qonuniy emas.",
        },
        {
            type: "p",
            text:
                "Ayrim tovar toifalarini internet orqali erkin sotish taqiqlangan yoki cheklangan: alkogol mahsulotlari, tamaki, dori vositalari, qimmatbaho metall va toshlardan yasalgan buyumlar shular jumlasidan. Bu ro'yxat va shartlar vaqti-vaqti bilan yangilanadi, shuning uchun savdoni boshlashdan oldin amaldagi normativ hujjatlarni yoki yuristni tekshirish zarur. Biz bu yerda aniq ro'yxatni keltirmaymiz — u eskirib qolishi mumkin.",
        },
        {
            type: "callout",
            text:
                "Texnik tomondan bu nimani anglatadi: do'konda ommaviy oferta, qaytarish shartlari, yetkazib berish qoidalari va shaxsiy ma'lumotlarni qayta ishlash siyosati sahifalari bo'lishi kerak. Bu sahifalarni biz shablon sifatida beramiz, lekin ularni yuristingiz tasdiqlashi kerak.",
        },

        { type: "h2", text: "Internet do'kon qancha turadi?" },
        {
            type: "p",
            text:
                "Narx tovarlar soniga emas, funksionalga bog'liq. 200 ta tovarli oddiy katalog 20 000 ta tovarli, variatsiyali va ombor hisobi bilan bog'langan katalogdan bir necha barobar arzon. Quyida Innobek narxlari.",
        },
        {
            type: "table",
            head: ["Variant", "Narxi (so'm)", "Muddat", "Nima kiradi"],
            rows: [
                [
                    "Bazaviy do'kon",
                    "16 000 000 dan",
                    "20–35 ish kuni",
                    "Katalog, savat, admin panel, Payme va Click, yetkazib berish, ikki til",
                ],
                [
                    "Kengaytirilgan",
                    "34 000 000 dan",
                    "35–60 ish kuni",
                    "Individual dizayn, ombor hisobi, sodiqlik dasturi, 1C integratsiyasi",
                ],
                [
                    "Marketpleys yoki B2B",
                    "70 000 000 dan",
                    "kelishuv asosida",
                    "Ko'p sotuvchili maydoncha, dilerlar kabineti, murakkab narxlash",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Narxga kirmaydigan uchta narsa bor va ular ko'pincha unutiladi. Birinchisi — hosting: yuklamasi katta do'kon uchun yiliga taxminan 1,5–3 mln so'm. Ikkinchisi — ekvayring komissiyasi, u to'g'ridan-to'g'ri Payme yoki Click'ga to'lanadi. Uchinchisi — fotosurat va tovar tavsiflari: 500 ta tovarli katalogni to'ldirish alohida ish va uni hech kim siz uchun bepul qilmaydi.",
        },

        { type: "h2", text: "Marketpleys yoki o'z do'koni — qaysi biri foydali?" },
        {
            type: "p",
            text:
                "Bu savolga hissiyot bilan emas, kalkulyator bilan javob beriladi. Asosiy o'zgaruvchi — komissiya foizi va sizning oylik aylanmangiz. Aniq foiz maydoncha va tovar toifasiga qarab farq qiladi, shuning uchun o'z shartnomangizdagi raqamni oling.",
        },
        {
            type: "table",
            head: ["Mezon", "Marketpleys", "O'z do'koningiz"],
            rows: [
                ["Boshlang'ich xarajat", "Deyarli yo'q", "16 mln so'mdan"],
                ["Har sotuvdan to'lov", "Komissiya, odatda sezilarli ulush", "Faqat ekvayring foizi"],
                ["Trafik", "Maydoncha beradi", "Siz olib kelasiz"],
                ["Mijoz bazasi", "Maydonchaniki", "Sizniki"],
                ["Brend va dizayn", "Cheklangan", "To'liq sizning nazoratingizda"],
                ["Qoidalar o'zgarishi", "Sizga bog'liq emas", "Siz belgilaysiz"],
            ],
        },
        {
            type: "p",
            text:
                "Endi hisob. Oylik aylanmangiz 60 mln so'm, komissiya 15% bo'lsin — bu oyiga 9 mln so'm. O'z do'koningizda faqat ekvayring qoladi, taxminan 1–2%, ya'ni 0,6–1,2 mln so'm. Farq oyiga 8 mln so'mga yaqin, demak 16 mln so'mlik do'kon nazariy jihatdan ikki oyda qoplanadi.",
        },
        {
            type: "p",
            text:
                "Amalda esa unday emas va buni ochiq aytish kerak. Marketpleys sizga trafik beradi, o'z do'koningizga trafikni siz sotib olasiz — reklama va SEO uchun oyiga kamida 4–6 mln so'm kerak bo'ladi. Shu qo'shimcha xarajat bilan real qaytim muddati 8–12 oyga cho'ziladi. Shuning uchun eng sog'lom strategiya — marketpleysni tashlab ketmaslik, balki o'z do'konini ikkinchi kanal sifatida qo'shish.",
        },

        { type: "h2", text: "Do'kon qachon o'zini oqlaydi?" },
        {
            type: "p",
            text:
                "Marketpleyssiz, noldan boshlaydigan do'kon uchun hisob boshqacha quriladi. Sizga to'rtta raqam kerak: oylik tashriflar, konversiya, o'rtacha chek va marja. Quyida o'rtacha chakana do'kon misolidagi hisob.",
        },
        { type: "image", image: 2 },
        {
            type: "ol",
            items: [
                "Oyiga 5 000 tashrif — reklama va SEO olti oy ishlagandan keyingi real ko'rsatkich.",
                "Konversiya 1,5% — 75 ta buyurtma. Elektron tijoratda 1–3% normal oraliq hisoblanadi.",
                "O'rtacha chek 400 000 so'm — oylik aylanma 30 mln so'm.",
                "Marja 25% — 7 500 000 so'm yalpi foyda.",
                "Reklama va SEO xarajati 4 000 000 so'm — sof natija oyiga 3 500 000 so'm.",
            ],
        },
        {
            type: "p",
            text:
                "16 mln so'mlik do'kon shu tezlikda taxminan besh oyda qoplanadi. Lekin birinchi oydan 5 000 tashrif bo'lmaydi: dastlabki uch oy trafik kam, buyurtma ham kam. Shuni hisobga olsak, real qaytim 9–14 oyni oladi. Agar o'rtacha chekingiz 400 ming emas, 2 mln so'm bo'lsa, xuddi shu hisob to'rt barobar tezroq chiqadi.",
        },

        { type: "h2", text: "Onlayn savdoga chiqmaslikning narxi qancha?" },
        {
            type: "p",
            text:
                "Hech narsa qilmaslik ham pul turadi. Faraz qiling, sohangizda oyiga 3 000 kishi mahsulotingizni onlayn qidiradi. Ulardan 1,5 foizi sotib oladi — bu 45 ta buyurtma. O'rtacha chek 400 000 so'm va marja 25% bo'lganda, bu oyiga 4,5 mln so'm, yiliga taxminan 54 mln so'm qo'lga kirmagan foyda.",
        },
        {
            type: "p",
            text:
                "Ikkinchi yo'qotish ko'rinmasroq: mijoz bazasi. Faqat marketpleysda sotsangiz, uch yildan keyin sizda o'z bazangiz bo'lmaydi. Maydoncha komissiyani ikki barobar oshirsa yoki toifangizni yopsa, siz nolga qaytasiz. O'z do'konida esa telefon raqamlari, xarid tarixi va takroriy sotuv sizda qoladi.",
        },
        {
            type: "p",
            text:
                "Uchinchi yo'qotish — vaqt. Buyurtmalarni yozishmadan daftarga ko'chirish oyiga o'nlab soat oladi va xato keltiradi. Bitta yo'qolgan buyurtma mijozni butunlay ketkazadi.",
        },

        { type: "h2", text: "Internet do'kon kimga mos emas?" },
        {
            type: "p",
            text:
                "Bu ro'yxat bizga foydali emas, lekin usiz maqola halol bo'lmaydi. Quyidagi holatlarda do'kon qurishga shoshilmang.",
        },
        {
            type: "list",
            items: [
                "Assortimentingiz 10–20 ta tovardan iborat va ular kamdan-kam o'zgaradi. Bunday holda katalog emas, oddiy sayt yoki Telegram bot yetadi va u besh barobar arzon.",
                "Logistika hal qilinmagan. Buyurtma kelgan bilan uni yetkazib bera olmasangiz, do'kon muammoni kattalashtiradi. Avval kuryer yoki yetkazib berish xizmati bilan shartnoma tuzing.",
                "Ombor qoldig'i yuritilmaydi. Saytda «bor» deb turgan tovar aslida tugagan bo'lsa, birinchi o'nta mijozni yo'qotasiz.",
                "Reklama byudjeti yo'q. Trafiksiz do'kon — bu bo'sh javonlar. Oyiga kamida 4 mln so'mni reklama uchun rejalashtira olmasangiz, kuting.",
                "Tovaringiz qonuniy cheklovga tushadi. Alkogol, dori yoki qimmatbaho metall bilan ishlasangiz, avval yurist bilan gaplashing, keyin dasturchi bilan.",
            ],
        },
        {
            type: "p",
            text:
                "Yana bir kamchilikni ochiq aytamiz: internet do'kon oddiy saytdan ko'ra ko'proq doimiy e'tibor talab qiladi. Tovar qo'shish, narx yangilash, sharhga javob berish, buyurtma yuritish — bu haftada bir necha soatlik doimiy ish. Bu ishni qiladigan odam bo'lmasa, do'kon ikki oydan keyin eskirib qoladi.",
        },

        { type: "h2", text: "Do'kon ishga tushgandan keyin nima qilish kerak?" },
        {
            type: "ol",
            items: [
                "Analytics va elektron tijorat hodisalarini ulang: savatga qo'shish, rasmiylashtirish boshlanishi, xarid. Busiz qaysi bosqichda odam ketayotganini bilmaysiz.",
                "Tashlab ketilgan savatlarga qaytish mexanizmini yoqing — bu odatda eng arzon qo'shimcha sotuv manbai.",
                "Tovar kartochkalarini to'ldiring: haqiqiy fotosurat, o'lcham, kafolat, yetkazib berish muddati. Bo'sh kartochka sotmaydi.",
                "Sahifa tezligini kuzating. Google'ning ochiq chegaralari: LCP 2,5 soniyagacha, CLS 0,1 dan past.",
                "Har oy hisobotni ko'rib chiqing: qaysi toifa foyda keltiryapti, qaysi reklama kanali zarar qilyapti.",
            ],
        },
        {
            type: "p",
            text:
                "Innobek'da olti oylik qo'llab-quvvatlash do'kon narxiga kiradi va kod sizga tegishli bo'ladi — bizga oylik platforma to'lovi to'lamaysiz. Keyinchalik xohlasangiz, oylik shartnoma tuzamiz yoki soatbay ishlaymiz.",
        },
        {
            type: "quote",
            text:
                "Internet do'kon tovarni sotmaydi — u sotuv jarayonini o'lchanadigan qiladi. Sotish baribir sizning ishingiz bo'lib qoladi.",
        },
    ],

    faq: [
        {
            q: "Internet do'kon yaratish qancha turadi?",
            a: "Innobek'da narxlar 16 000 000 so'mdan boshlanadi — bu to'liq ishlaydigan do'kon: katalog, savat, admin panel, Payme va Click to'lovlari, yetkazib berish sozlamalari va ikki tillilik. Individual dizayn, ombor hisobi, sodiqlik dasturi va 1C integratsiyasi bilan variant 34 000 000 so'mdan. Ko'p sotuvchili maydoncha yoki B2B kabinet kerak bo'lsa, narx loyihaga qarab hisoblanadi va odatda 70 mln so'mdan oshadi.",
        },
        {
            q: "Marketpleysda sotaman, menga o'z do'konim kerakmi?",
            a: "Bu aylanma va komissiyaga bog'liq. Oyiga 60 mln so'm aylanma va 15% komissiyada siz maydonchaga 9 mln so'm to'laysiz, o'z do'koningizda esa faqat ekvayring foizi qoladi. Lekin marketpleys sizga trafik beradi, o'z do'koningizga esa trafikni siz sotib olasiz. Shu sababli biz marketpleysni tashlab ketishni emas, o'z do'konini ikkinchi kanal sifatida qo'shishni tavsiya qilamiz.",
        },
        {
            q: "Do'kon qancha vaqtda o'zini oqlaydi?",
            a: "Marketpleysdan o'tayotgan biznes uchun komissiya tejamiga qarab odatda 8–12 oy. Noldan boshlayotgan do'kon uchun 9–14 oy: birinchi uch oyda trafik kam bo'ladi. Muddat o'rtacha chekingizga juda bog'liq — chek 400 ming so'mdan 2 mln so'mga oshsa, qaytim to'rt barobar tezlashadi. Maqoladagi besh qadamli hisobga o'z raqamlaringizni qo'yib ko'ring.",
        },
        {
            q: "Onlayn savdo uchun qanday hujjatlar kerak?",
            a: "«Elektron tijorat to'g'risida»gi Qonunga (O'RQ-792-son, 2022-yil) muvofiq sotuvchi yuridik shaxs, yakka tartibdagi tadbirkor yoki o'zini o'zi band qilgan shaxs bo'lishi kerak. Saytda ommaviy oferta, qaytarish shartlari, yetkazib berish qoidalari va shaxsiy ma'lumotlar siyosati sahifalari bo'lishi lozim. Biz bu sahifalarni shablon sifatida beramiz, yakuniy matnni yuristingiz tasdiqlaydi.",
        },
        {
            q: "Do'konda qanday to'lov usullarini ulash mumkin?",
            a: "O'zbekiston bozori uchun standart to'plam — Payme va Click, ularni biz to'g'ridan-to'g'ri ulaymiz. Bundan tashqari yetkazib berishda naqd to'lov varianti deyarli har doim qoldiriladi, chunki auditoriyaning sezilarli qismi hali ham shunday to'laydi. Ekvayring komissiyasi to'lov tizimiga to'g'ridan-to'g'ri to'lanadi va do'kon narxiga kirmaydi.",
        },
        {
            q: "Do'konga har oy qancha xarajat ketadi?",
            a: "Bizga oylik platforma to'lovi yo'q — kod sizga tegishli. Doimiy xarajatlar uchta: hosting va domen (yuklamaga qarab yiliga taxminan 1,5–3 mln so'm), to'lov tizimining ekvayring foizi va reklama byudjeti. Oxirgisi eng kattasi: trafiksiz do'kon ishlamaydi, shuning uchun oyiga kamida 4–6 mln so'mni reklama va SEO uchun rejalashtiring.",
        },
        {
            q: "Qaysi holatda internet do'kon qurish tavsiya qilinmaydi?",
            a: "Assortimentingiz 10–20 ta tovardan iborat bo'lsa, oddiy sayt yoki Telegram bot besh barobar arzon tushadi. Logistika hal qilinmagan yoki ombor qoldig'i yuritilmasa, do'kon muammoni kattalashtiradi. Reklama byudjeti rejalashtirilmagan bo'lsa ham kutgan ma'qul — trafiksiz do'kon bo'sh javonlar bilan barobar. Tovaringiz qonuniy cheklovga tushsa, avval yurist bilan maslahatlashing.",
        },
    ],

    cta: {
        h: "Do'kon sizga foydalimi — hisoblab beramiz",
        p:
            "Aylanmangiz, komissiya foizingiz va o'rtacha chekingizni ayting — o'z do'koningiz necha oyda o'zini oqlashini raqam bilan ko'rsatamiz. Foydasiz chiqsa, buni ham ochiq aytamiz.",
        button: "Hisob olish",
    },

    images: [
        {
            src: "/assets/img/blog/ecom-cover.webp",
            alt: "Internet do'kon katalogi va savat sahifasi noutbuk hamda smartfon ekranida",
            caption: "Internet do'kon — masofadan ishlaydigan va to'liq o'lchanadigan savdo kanali",
        },
        {
            src: "/assets/img/blog/ecom-steps.webp",
            alt: "Internet do'kon ochish bosqichlari: katalog, savat, to'lov va yetkazib berish",
            caption: "Xaridor yo'li: katalogdan savatga, savatdan buyurtmani rasmiylashtirishga",
        },
        {
            src: "/assets/img/blog/ecom-growth.webp",
            alt: "Onlayn savdo aylanmasi va buyurtmalar sonining oylar bo'yicha o'sish grafigi",
            caption: "Birinchi uch oyda buyurtma kam bo'ladi — qaytim shundan keyin boshlanadi",
        },
        {
            src: "/assets/img/blog/cleanza-arxitektura.webp",
            alt: "Internet do'kon arxitekturasi: vitrina, admin panel va buyurtma oqimi bog'lanishi",
            caption: "Do'konning ichki tuzilishi: vitrina, admin panel, to'lov va buyurtma oqimi",
        },
    ],

    relatedServices: ["internet-dokonlar", "crm-tizimlar", "telegram-bot"],
    relatedPosts: ["web-sayt", "turlari"],
};

const ru = {
    meta: {
        title: "Как работает интернет-магазин и кому он выгоден",
        description:
            "Как устроен интернет-магазин, из чего состоит и сколько стоит. Цена от 16 млн сум, сравнение с маркетплейсом, расчёт окупаемости и требования закона.",
        keywords: [
            "интернет-магазин",
            "онлайн-магазин",
            "как работает интернет-магазин",
            "окупаемость интернет-магазина",
            "электронная коммерция",
            "онлайн-продажи",
            "маркетплейс или свой магазин",
        ],
    },
    h1: "Интернет-магазин: как он работает, сколько стоит и когда окупается",
    lead:
        "Интернет-магазин — не торговая точка, а канал с измеримой экономикой. Разбираем, из чего он собирается, какие требования закона действуют в Узбекистане, когда он выгоднее маркетплейса и как посчитать окупаемость.",
    category: "Электронная коммерция",
    readingTime: "11 минут",

    body: [
        {
            type: "p",
            text:
                "«Мы продаём на маркетплейсе, нужен ли нам свой магазин?» — самый частый вопрос, который нам задают. Ответ зависит от оборота и процента комиссии, и больше ни от чего. Ниже показываем этот расчёт открыто.",
        },

        { type: "h2", text: "Что такое интернет-магазин и как он работает?" },
        {
            type: "p",
            text:
                "Интернет-магазин — сайт, предназначенный для продажи товаров через интернет. Покупатель выбирает товар на компьютере или смартфоне, оформляет заказ, указывает способ оплаты и доставки. Торговля идёт дистанционно — продавец и покупатель не встречаются.",
        },
        {
            type: "p",
            text:
                "С точки зрения покупателя продажа проходит в три шага. Первый — каталог: товары разложены по категориям, у каждого фото, цена и описание. Задача та же, что у полки в магазине, только полка бесконечная.",
        },
        {
            type: "p",
            text:
                "Второй шаг — корзина: покупатель складывает выбранное, видит сумму, меняет количество. Третий — оформление заказа: контакты, адрес доставки, способ оплаты. В эту минуту заказ попадает в систему продавца.",
        },
        { type: "image", image: 1 },
        {
            type: "p",
            text:
                "Здесь начинается невидимая часть: заказ появляется в админке, остаток уменьшается, клиенту уходит подтверждение, курьеру формируется задание. Без автоматизации этой цепочки магазином невозможно управлять вручную уже после 200 заказов в месяц.",
        },

        { type: "h2", text: "Из чего собирается интернет-магазин?" },
        {
            type: "p",
            text:
                "Снаружи магазин выглядит единым сайтом, на деле он состоит минимум из пяти частей. Чтобы понимать цену, нужно видеть это деление.",
        },
        { type: "image", image: 3 },
        {
            type: "list",
            items: [
                "Витрина — то, что видит покупатель: каталог, фильтры, поиск, карточка товара, корзина и форма заказа.",
                "Админ-панель — добавление товаров, изменение цен и остатков, просмотр заказов и ведение их статусов.",
                "Модуль оплаты — интеграция Payme и Click, а также вариант оплаты наличными при доставке.",
                "Доставка — зоны, тарифы, минимальная сумма заказа и связка со службой курьеров.",
                "Аналитика — какие товары смотрят, на каком шаге бросают корзину, из какого канала приходят заказы.",
            ],
        },
        {
            type: "p",
            text:
                "Дополнением идут CRM и Telegram-бот. CRM ведёт повторные продажи: база клиентов, история звонков, возврат к брошенным корзинам. Бот сообщает статус заказа и запускается быстрее приложения.",
        },

        { type: "h2", text: "Чем интернет-магазин лучше обычного?" },
        {
            type: "p",
            text:
                "Преимущество онлайн-торговли не в дизайне, а в экономике. Пять пунктов ниже — то, что в офлайне невозможно в принципе.",
        },
        {
            type: "list",
            items: [
                "Работает 24 часа в сутки и 365 дней в году. Заказы принимаются в обед, в выходной и в праздник — даже когда продавец спит.",
                "Нет географических границ. Магазин в Ташкенте так же близок покупателю из Ферганы или Нукуса, как соседняя улица.",
                "Ассортимент не ограничен. Место на полке не кончается: и 50 товаров, и 50 000 помещаются на одну витрину.",
                "Каждое действие измеримо. Видно, сколько раз смотрели товар и на каком шаге бросили корзину. В офлайне этого не узнать.",
                "Падают расходы на аренду и продавцов. Вместо торговой точки достаточно одного склада и одного оператора.",
            ],
        },
        {
            type: "p",
            text:
                "Важная оговорка: всё это не включается в день запуска. В обычный магазин человек заходит с улицы сам, а в интернет-магазин трафик приводите вы. Эта разница и хоронит большинство проектов.",
        },

        { type: "h2", text: "Какие правила действуют для онлайн-торговли в Узбекистане?" },
        {
            type: "p",
            text:
                "Основной документ — Закон «Об электронной коммерции» в новой редакции, принятый в сентябре 2022 года (ЗРУ-792). По нему электронные документы в электронной коммерции приравниваются к оформленным на бумаге и подписанным собственноручно. То есть заказ на сайте — это полноценный договор.",
        },
        {
            type: "p",
            text:
                "Продавцами на торговой площадке закон называет юрлиц, индивидуальных предпринимателей и самозанятых. Для старта онлайн-торговли нужен официальный статус — вариант «просто попробую поторговать» законом не предусмотрен.",
        },
        {
            type: "p",
            text:
                "Отдельные категории товаров продавать через интернет запрещено или ограничено: алкоголь, табак, лекарства, изделия из драгоценных металлов и камней. Перечень периодически обновляется, поэтому перед стартом проверьте действующие акты или спросите юриста. Конкретный список здесь не приводим — он может устареть.",
        },
        {
            type: "callout",
            text:
                "Что это значит технически: в магазине должны быть страницы публичной оферты, условий возврата, правил доставки и политики обработки персональных данных. Мы отдаём их как шаблон, но финальный текст должен подтвердить ваш юрист.",
        },

        { type: "h2", text: "Сколько стоит интернет-магазин?" },
        {
            type: "p",
            text:
                "Цена зависит не от числа товаров, а от функционала. Каталог на 200 позиций в разы дешевле каталога на 20 000 позиций с вариациями и складом. Ниже — тарифы Innobek.",
        },
        {
            type: "table",
            head: ["Вариант", "Цена (сум)", "Срок", "Что входит"],
            rows: [
                [
                    "Базовый магазин",
                    "от 16 000 000",
                    "20–35 рабочих дней",
                    "Каталог, корзина, админка, Payme и Click, доставка, два языка",
                ],
                [
                    "Расширенный",
                    "от 34 000 000",
                    "35–60 рабочих дней",
                    "Индивидуальный дизайн, складской учёт, лояльность, интеграция с 1С",
                ],
                [
                    "Маркетплейс или B2B",
                    "от 70 000 000",
                    "по договорённости",
                    "Площадка с несколькими продавцами, кабинет дилера, сложное ценообразование",
                ],
            ],
        },
        {
            type: "p",
            text:
                "В цену не входят три вещи, и о них обычно забывают. Первая — хостинг: для нагруженного магазина это 1,5–3 млн сум в год. Вторая — комиссия эквайринга, она идёт напрямую Payme или Click. Третья — фотографии и описания: заполнить каталог на 500 позиций — это отдельная работа, бесплатно её никто не сделает.",
        },

        { type: "h2", text: "Маркетплейс или свой магазин — что выгоднее?" },
        {
            type: "p",
            text:
                "На этот вопрос отвечают калькулятором, а не эмоциями. Главные переменные — процент комиссии и месячный оборот. Процент зависит от площадки и категории, поэтому берите цифру из своего договора.",
        },
        {
            type: "table",
            head: ["Критерий", "Маркетплейс", "Свой магазин"],
            rows: [
                ["Стартовые вложения", "Практически нет", "От 16 млн сум"],
                ["Платёж с каждой продажи", "Комиссия, обычно заметная доля", "Только процент эквайринга"],
                ["Трафик", "Даёт площадка", "Приводите вы"],
                ["База клиентов", "Принадлежит площадке", "Принадлежит вам"],
                ["Бренд и дизайн", "Ограничены", "Полностью под вашим контролем"],
                ["Изменение правил", "От вас не зависит", "Определяете вы"],
            ],
        },
        {
            type: "p",
            text:
                "Теперь расчёт. Допустим, оборот 60 млн сум в месяц, комиссия 15% — это 9 млн сум ежемесячно. В своём магазине остаётся только эквайринг, примерно 1–2%, то есть 0,6–1,2 млн сум. Разница около 8 млн сум в месяц, и магазин за 16 млн теоретически окупается за два месяца.",
        },
        {
            type: "p",
            text:
                "На практике всё иначе, и об этом надо говорить прямо. Маркетплейс даёт вам трафик, а в свой магазин трафик вы покупаете — на рекламу и SEO уйдёт минимум 4–6 млн сум в месяц. С учётом этого реальная окупаемость растягивается до 8–12 месяцев. Поэтому здоровая стратегия — не уходить с маркетплейса, а добавить свой магазин вторым каналом.",
        },

        { type: "h2", text: "За какой срок магазин окупается?" },
        {
            type: "p",
            text:
                "Для магазина, который стартует с нуля без маркетплейса, расчёт строится иначе. Нужны четыре числа: месячный трафик, конверсия, средний чек и маржа. Ниже — пример для среднего розничного магазина.",
        },
        { type: "image", image: 2 },
        {
            type: "ol",
            items: [
                "5 000 визитов в месяц — реальный показатель через полгода работы рекламы и SEO.",
                "Конверсия 1,5% — 75 заказов. В электронной коммерции нормальным считается диапазон 1–3%.",
                "Средний чек 400 000 сум — оборот 30 млн сум в месяц.",
                "Маржа 25% — 7 500 000 сум валовой прибыли.",
                "Расходы на рекламу и SEO 4 000 000 сум — чистый результат 3 500 000 сум в месяц.",
            ],
        },
        {
            type: "p",
            text:
                "При такой скорости магазин за 16 млн сум окупается примерно за пять месяцев. Но 5 000 визитов с первого месяца не будет: первые три месяца трафика мало, заказов тоже. С этой поправкой реальная окупаемость занимает 9–14 месяцев. При среднем чеке 2 млн сум вместо 400 тысяч магазин окупается вчетверо быстрее.",
        },

        { type: "h2", text: "Сколько стоит не выходить в онлайн?" },
        {
            type: "p",
            text:
                "Бездействие тоже стоит денег. Допустим, в вашей нише 3 000 человек в месяц ищут ваш товар онлайн, и 1,5% из них покупают — это 45 заказов. При среднем чеке 400 000 сум и марже 25% получается 4,5 млн сум в месяц и около 54 млн сум в год неполученной прибыли.",
        },
        {
            type: "p",
            text:
                "Вторая потеря менее заметна — база клиентов. Продавая только на маркетплейсе, через три года вы остаётесь без собственной базы. Площадка удвоит комиссию или закроет категорию — и вы возвращаетесь к нулю. В своём магазине телефоны и история покупок остаются у вас.",
        },
        {
            type: "p",
            text:
                "Третья потеря — время. Переписывать заказы из чата в тетрадь — это десятки часов в месяц и гарантированные ошибки. Один потерянный заказ уводит клиента навсегда.",
        },

        { type: "h2", text: "Кому интернет-магазин не подходит?" },
        {
            type: "p",
            text:
                "Этот список нам невыгоден, но без него статья была бы нечестной. В перечисленных случаях с магазином лучше не спешить.",
        },
        {
            type: "list",
            items: [
                "У вас 10–20 товаров, и они почти не меняются. Тогда нужен не каталог, а обычный сайт или Telegram-бот — выйдет в пять раз дешевле.",
                "Не решена логистика. Если заказ пришёл, а доставить его нечем, магазин только увеличит проблему. Сначала договор с курьерской службой.",
                "Не ведётся складской учёт. Товар, который на сайте «в наличии», а на деле закончился, стоит вам первых десяти клиентов.",
                "Нет бюджета на рекламу. Магазин без трафика — это пустые полки. Если не получается заложить хотя бы 4 млн сум в месяц, подождите.",
                "Ваш товар попадает под ограничения. Алкоголь, лекарства, драгметаллы — сначала юрист, потом разработчик.",
            ],
        },
        {
            type: "p",
            text:
                "Назовём прямо и ещё один минус: магазин требует куда больше постоянного внимания, чем обычный сайт. Добавить товар, обновить цену, ответить на отзыв — это несколько часов каждую неделю. Если этим некому заниматься, через два месяца магазин устаревает.",
        },

        { type: "h2", text: "Что делать после запуска магазина?" },
        {
            type: "ol",
            items: [
                "Подключите аналитику и события электронной коммерции: добавление в корзину, начало оформления, покупка. Без этого не видно, на каком шаге уходят люди.",
                "Включите возврат к брошенным корзинам — обычно это самый дешёвый источник дополнительных продаж.",
                "Заполните карточки товаров: настоящие фото, размеры, гарантия, срок доставки. Пустая карточка не продаёт.",
                "Следите за скоростью страниц. Официальные пороги Google: LCP до 2,5 секунды, CLS ниже 0,1.",
                "Раз в месяц разбирайте отчёт: какая категория приносит прибыль, какой рекламный канал работает в минус.",
            ],
        },
        {
            type: "p",
            text:
                "В Innobek шесть месяцев поддержки входят в стоимость магазина, а код принадлежит вам — ежемесячной платы за платформу нет. Дальше при желании заключаем договор на обслуживание или работаем почасово.",
        },
        {
            type: "quote",
            text:
                "Интернет-магазин не продаёт товар — он делает процесс продажи измеримым. Продавать по-прежнему придётся вам.",
        },
    ],

    faq: [
        {
            q: "Сколько стоит создание интернет-магазина?",
            a: "В Innobek цены начинаются от 16 000 000 сум — это полностью работающий магазин: каталог, корзина, админ-панель, оплата Payme и Click, настройка доставки и два языка. Вариант с индивидуальным дизайном, складским учётом, программой лояльности и интеграцией с 1С — от 34 000 000 сум. Для площадки с несколькими продавцами или B2B-кабинета цена считается по проекту и обычно превышает 70 млн сум.",
        },
        {
            q: "Я продаю на маркетплейсе — нужен ли мне свой магазин?",
            a: "Зависит от оборота и комиссии. При обороте 60 млн сум в месяц и комиссии 15% вы отдаёте площадке 9 млн сум, а в своём магазине остаётся только процент эквайринга. Но маркетплейс даёт вам трафик, а в свой магазин трафик придётся покупать. Поэтому мы советуем не уходить с площадки, а добавить собственный магазин вторым каналом.",
        },
        {
            q: "За какой срок магазин окупается?",
            a: "Для бизнеса, который переходит с маркетплейса, обычно 8–12 месяцев за счёт экономии на комиссии. Для магазина с нуля — 9–14 месяцев, потому что в первые три месяца трафика мало. Срок сильно зависит от среднего чека: рост чека с 400 тысяч до 2 млн сум ускоряет окупаемость примерно вчетверо. Подставьте свои числа в расчёт из статьи.",
        },
        {
            q: "Какие документы нужны для онлайн-торговли?",
            a: "По Закону «Об электронной коммерции» (ЗРУ-792, 2022 год) продавцом может быть юридическое лицо, индивидуальный предприниматель или самозанятый. На сайте должны быть публичная оферта, условия возврата, правила доставки и политика обработки персональных данных. Мы отдаём эти страницы как шаблон, а финальный текст утверждает ваш юрист.",
        },
        {
            q: "Какие способы оплаты можно подключить?",
            a: "Стандартный набор для узбекского рынка — Payme и Click, их мы подключаем напрямую. Кроме того, почти всегда оставляют оплату наличными при доставке, потому что заметная часть аудитории платит именно так. Комиссия эквайринга платится платёжной системе напрямую и в стоимость магазина не входит.",
        },
        {
            q: "Сколько магазин стоит в обслуживании каждый месяц?",
            a: "Ежемесячной платы за платформу мы не берём — код принадлежит вам. Постоянных расходов три: хостинг и домен (примерно 1,5–3 млн сум в год в зависимости от нагрузки), процент эквайринга и рекламный бюджет. Последний самый крупный: без трафика магазин не работает, поэтому закладывайте минимум 4–6 млн сум в месяц.",
        },
        {
            q: "В каких случаях интернет-магазин делать не стоит?",
            a: "Если у вас 10–20 товаров, обычный сайт или Telegram-бот обойдётся в пять раз дешевле. Если не решена логистика или не ведётся складской учёт, магазин только усилит проблему. Если бюджет на рекламу не запланирован, тоже лучше подождать — магазин без трафика равнозначен пустым полкам.",
        },
    ],

    cta: {
        h: "Посчитаем, выгоден ли вам свой магазин",
        p:
            "Назовите оборот, процент комиссии и средний чек — покажем в цифрах, за сколько месяцев окупится собственный магазин. Если выйдет невыгодно, скажем об этом прямо.",
        button: "Получить расчёт",
    },

    images: [
        {
            src: "/assets/img/blog/ecom-cover.webp",
            alt: "Каталог интернет-магазина и страница корзины на экране ноутбука и смартфона",
            caption: "Интернет-магазин — дистанционный и полностью измеримый канал продаж",
        },
        {
            src: "/assets/img/blog/ecom-steps.webp",
            alt: "Этапы запуска интернет-магазина: каталог, корзина, оплата и доставка заказа",
            caption: "Путь покупателя: из каталога в корзину, из корзины в оформление заказа",
        },
        {
            src: "/assets/img/blog/ecom-growth.webp",
            alt: "График роста оборота и количества заказов интернет-магазина по месяцам",
            caption: "В первые три месяца заказов мало — окупаемость начинается после них",
        },
        {
            src: "/assets/img/blog/cleanza-arxitektura.webp",
            alt: "Схема архитектуры интернет-магазина: витрина, админ-панель и поток заказов",
            caption: "Устройство магазина: витрина, админка, оплата и поток заказов",
        },
    ],

    relatedServices: ["internet-dokonlar", "crm-tizimlar", "telegram-bot"],
    relatedPosts: ["web-sayt", "turlari"],
};

const content = { uz, ru };

export default content;
